<template>

  <div class="middle-box text-center loginscreen animated fadeInDown">

    <div class="image-logo">
      <img src="/static/img/logo-ssparisi.png" alt="Logo">
    </div>

    <h3 class="font-bold">Redefinir senha</h3>

    <div class="error-desc">
      Crie uma senha nova abaixo.
      <form class="m-t" role="form">

        <div class="form-group">
          <input v-model="newPass" :type="passInputType()" class="form-control" name="new_password" placeholder="Senha nova"
            v-validate="'required|min:4'" :class="{invalid: errors.has('new_password')}">
          <span class="error">{{ errors.first('new_password') }}</span>
        </div>
        <div class="form-group">
          <input :type="passInputType()" class="form-control" name="confirm_password" placeholder="Confirmação da senha nova"
            v-validate="{ confirmed: newPass, required: true }" :class="{invalid: errors.has('confirm_password')}">
          <span class="error">{{ errors.first('confirm_password') }}</span>
        </div>

        <button class="btn btn-success btn-block" @click.prevent="resetPassword()"> Enviar </button>

        <div class="form-check">
          <input class="form-check-input" type="checkbox" @click="togglePassVisibility">
          <label class="form-check-label"> Exibir senha</label>
        </div>

      </form>

      <br />

      <a href="#" @click.prevent="$router.go(-1)">Voltar</a>

    </div>

    <p class="m-t"><small>SS PARISI todos direitos reservados &copy; {{ year }}</small></p>

  </div>

</template>

<script>

  import { httpService } from '../providers/http-service'
  import { toast } from '../mixins/toast'

  export default {
    mixins: [ toast ],
    data() {
      return {
        newPass: '',
        token: '',
        year: new Date().getFullYear()
      }
    },
    methods: {
      togglePassVisibility() { this.passVisible = !this.passVisible },
      passInputType() { return this.passVisible ? 'text' : 'password' },

      resetPassword() {
        this.$validator.validateAll().then((valid) => {
          if(valid) {
            httpService.resetPassword({ token: this.token, newPass: this.newPass }).then((res) => {
              if(res.status === 200) {
                if(res.data.error) {
                  this.show_toast('error', 'Ops!', res.data.msg)
                } else {
                  this.show_toast('success', 'Senha redefinida com sucesso', 'Você já pode realizar login com sua nova senha.')
                  this.$router.push('/')
                }
              }
            }).catch((err) => {
              this.show_toast('error', 'Falha ao redefinir senha', 'Você solicitou a redefinição de senha??')
            })
          } else {
            this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
            this.$validator.validateAll()
          }
        })
      }
    }, mounted() {
      this.token = this.$route.query.token
      if(!this.token || this.token === '') {
        this.$router.push('/')
      }
    }
  }
</script>

<style scoped>

  .image-logo { height: 200px; position: relative; }

  .image-logo img{
    display: block;
    max-width: 100%;
    position: absolute;
    bottom:0;
    left:50%;
    transform:translateX(-50%);
  }

</style>



// WEBPACK FOOTER //
// src/components/ResetPasswordPage.vue